var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"container view"},[_c('HeaderComponent',{attrs:{"title":_vm.$metaInfo.title}}),_c('StepperComponent',{ref:"stepper",attrs:{"value":_vm.steps,"state-handler":"route","submit":"submit"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }